import { BellFilled } from '../../icons/sidebar/bell-filled'
import { BellIcon } from '../../icons/sidebar/bell-icon'
import { Briefcase } from '../../icons/sidebar/briefcase'
import { BriefcaseFilled } from '../../icons/sidebar/briefcase-filled'
import { ChatFilled } from '../../icons/sidebar/chat-filled'
import { ChatIcon } from '../../icons/sidebar/chat-icon'
import { House } from '../../icons/sidebar/house'
import { HouseFilled } from '../../icons/sidebar/house-filled'
import { SearchIcon } from '../../icons/sidebar/search-icon'

const iconMap = {
  briefcase: Briefcase,
  briefcaseFilled: BriefcaseFilled,
  house: House,
  houseFilled: HouseFilled,
  chat: ChatIcon,
  chatFilled: ChatFilled,
  bell: BellIcon,
  bellFilled: BellFilled,
  search: SearchIcon,
}

export type IconName = keyof typeof iconMap

interface TabButtonIconProps {
  name: IconName
  className?: string
}

export default function TabButtonIcon({ name, className }: TabButtonIconProps) {
  const Icon = iconMap[name]

  return <Icon className={className} />
}
